import { Button } from '@dextech-ai/dex-design-system'
import DexLeftComponent from '@/components/DexLeftComponent'
import Toast from '@/components/Toast'
import usePage from '@/hooks/use-page'
import useToast from '@/hooks/use-toast'
import { useLocation, useNavigate, useQuery } from '@/lib/router-dom'
import API_EMAIL from '@/services/api/forgetPassword.js'
import { useState } from 'react'
import { Box } from '@dextech-ai/dex-design-system'

const Page = () => {

	/*=================================================
		General
	/================================================*/
	usePage({ title: 'Forget Password' })

	const { goTo } = useNavigate()
	const { currentState } = useLocation()
	const query = useQuery()
	const emailAddress = (query.get("email") || currentState?.email	|| "").toLowerCase()

	const toastType = {
		success: "success",
		error: "error"
	}

	const [loading, setLoading] = useState(false)

	const { toastList, addToastMessage } = useToast()

	async function submitHandler() {
		setLoading(true)
		const [error, _response] = await API_EMAIL.create({ email: emailAddress })
		setLoading(false)
		if (error) {
			return addToastMessage(error?.message ?? "Failed to reset password", toastType.error)
		}
		goTo('/forget-password/success')
	}

	return (
		<>
			<div className='layout-login'>
				<DexLeftComponent />
				<div className='layout-login__right'>
					<div className="login-box">
						<div className="forgetPassword-box__title">Forgot Password?</div>

						{emailAddress && (<div className="forgetPassword-box__desc">We will send you a reset link to your registered email address.</div>)}
						<div className="forgetPassword-box__form">
							<div className="forgetPassword-box__form__cols">
								<div className="forgetPassword-box__form__col">
								</div>
								<Box mt={10}>
									<div>
										{emailAddress && (
											<Button id="forgot-password-send-link-button"
											type="button" fullWidth style={{ maxWidth: '168px' }} loading={loading}
											iconOnly={loading} aria-label={loading ? 'Sending link' : undefined}
											onClick={()=>submitHandler()}>Send Link</Button>
										)}
									</div>
									<div className='link forgetPassword-box__form__action__bottom' onClick={() => goTo('/login')}>Back </div>
								</Box>
							</div>
						</div>
					</div>
				</div>
			</div>
			<Toast toastList={toastList} />
		</>


	)
}
export default Page
